import React from 'react';
import { Card, Row, Form, Button, Select, Col, Typography, Input, message, Tooltip, Icon, Radio, Spin } from "antd"
import { API, Auth } from "aws-amplify"
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom'
import mpago from '../../Images/mpago.png'
import {CustomSpinner} from "../Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

const { Option } = Select;
const { Paragraph } = Typography;
var interval = null;
var count = 0

class MercadoPagoMP extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            documentTypes: [],
            loading: true,
            paymentRejected: false,
            loadingPlans: true,
            issuerOptions: [],
            doSubmit: false,
            issuerRequired: false,
            paymentResponse: {},
            docMinLength: 7,
            mpResponse: {},
            docMaxLength: 8,
            id: '',
            plan: {},
            formData: {
                cardholderName: '',
                email: '',
                docType: 'DNI',
                docNumber: '',
                cardExpirationMonth: '',
                cardExpirationYear: '',
                cardNumber: '',
                securityCode: '',
                issuer: '', //Bco emisor
                insstallments: '1', //cuotas
                transactionAmount: '',
                paymentMethodId: '',
                description: '',
                paymentMethod: '',
            },
            card: {
                name: 'token',
                type: 'hidden',
                value: ''
            }

        }
        this.getIssuers = this.getIssuers.bind(this);
        this.setIssuers = this.setIssuers.bind(this);
        this.getCardToken = this.getCardToken.bind(this);
        this.setCardTokenAndPay = this.setCardTokenAndPay.bind(this)
        this.guessPaymentMethod = this.guessPaymentMethod.bind(this);
        this.setPaymentMethod = this.setPaymentMethod.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleResponse = this.handleResponse.bind(this)
    }


    componentDidMount() {
        window.Mercadopago.setPublishableKey("APP_USR-59fb9280-bf19-4e97-945b-8e4dc2b10c99");
        window.Mercadopago.getIdentificationTypes((status, getIdTypes) => {
            this.setState({ documentTypes: getIdTypes, loading: false })
        });

        const planId = (this.props.match.params.id !== undefined) ? this.props.match.params.id : this.props.plan_id;

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/planes/' + planId,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({ loadingPlans: false, plan: response })
                    })
                    .catch(err => {
                        message.error('Error leyendo tabla de planes')
                        this.setState({ loadingPlans: false })
                    })
            })
    }

    componentWillUnmount() {
        if (interval !== null) {
            clearInterval(interval)
        }
    }

    handleSubmit(event) {
        event.preventDefault()
        this.getCardToken()
    }

    handleChange(field, value) {
        let newData = { ...this.state.formData }
        newData[field] = value
        this.setState({ formData: newData })
        switch (field) {
            case 'cardNumber':
                if (value === null) {
                    break;
                } else {
                    this.guessPaymentMethod(value)
                    break;
                }
            case 'docType':
                let docData = this.state.documentTypes.filter(type => type.id === value)[0]
                this.setState({ docMinLength: docData.min_length, docMaxLength: docData.max_length })
                break;
            default:
                break;
        }
    }

    guessPaymentMethod(card) {

        let cardnumber = card.toString().replace(/\W/g, "");
        if (cardnumber.length >= 6) {
            let bin = cardnumber.substring(0, 6);
            window.Mercadopago.getPaymentMethod({
                "bin": bin
            }, this.setPaymentMethod);
        }
    }

    call_api() {
        this.setState({ loading: true })
        Auth.currentSession()
            .then(session => {
                API.post(
                    'test',
                    '/payment',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: {
                            card_token: this.state.card.value,
                            transaction_amount: this.state.plan.costo,
                            installments: this.state.formData.insstallments,
                            payment_method_id: this.state.formData.paymentMethodId,
                            payment_method: this.state.formData.paymentMethod,//credit_card, debit_card, ticket
                            payer_email: this.state.formData.paymentMethod === 'ticket' ? this.props.login.user_data.email : this.state.formData.email,
                            plan_id: this.state.plan.planId,
                            plan_month: this.state.plan.plazo,
                            first_name: this.props.login.user_data.nombre,
                            last_name: this.props.login.user_data.apellido,
                            payer_id_number: this.state.formData.docNumber,
                            payer_id_type: this.state.formData.docType,
                            mp_customer_id: this.props.login.user_data.mp_customer_id === (null || undefined) ? null : this.props.login.user_data.mp_customer_id,
                            customer_email: this.props.login.user_data.email,
                            customer_cuit: this.props.login.user_data.cuit,
                            plan: this.state.plan.plan,
                            deviceId: window.MP_DEVICE_SESSION_ID
                        }
                    }
                )
                    .then(response => {
                        this.setState({ paymentResponse: response })

                        if (response.payment_id === 'ERROR' || response['msg'] ==='Payment not creted') {
                            message.error("No se pudo generar el pago, reintenta con otro medio")
                            this.setState({ loading: false })

                        } else if (this.state.formData.paymentMethod === 'ticket') {
                            if (response['ticket_link']=== undefined || response['ticket_link']=== null ){
                                message.error('No se pudo generar el ticket de pago. Reintenta con otro medio')
                            } else{
                            window.open(response['ticket_link'], '_blank')
                            let state = this.props.login.user_data
                            state['estado_pago']='PAGO_EN_PROCESO'
                            state['plan_id']=this.state.plan.planId
                            this.props.UserDataLoad(state)
                            this.props.history.push('/mp')
                            }}
                        else {
                            interval = setInterval(this.handleResponse, 4000, response)
                        }

                    })
                    .catch(err => {
                            message.error("Ocurrió un error generando el pago")
                            this.setState({ loading: false })
                            this.props.history.push('/mp')
                    })
            })
            .catch(err => {
                message.error("Error obteniendo credenciales de usuario")
            })
    }

    handleResponse(paymentResponse) {
        window.Mercadopago.clearSession();
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/payment',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                        queryStringParameters: {
                            payment_id: paymentResponse.payment_id,
                            payment_timestamp: paymentResponse.payment_timestamp
                        }
                    }

                )
                    .then(response => {
                        if (count > 3) {
                            clearInterval(interval)
                            message.warning('Tu pago se encuentra pendiente')
                            this.props.history.push('/')
                        }
                        else {
                            count = count + 1
                            switch (response.status) {

                                case 'APPROVED':
                                    message.success('Pago aprobado!')
                                    clearInterval(interval)
                                    let state = this.props.login.user_data
                                    state['plan_id']=this.state.plan.planId
                                    state['estado_pago']='ACTIVO'
                                    this.props.UserDataLoad(state)
                                    this.props.history.push('/mp')
                                    break;

                                case 'REJECTED':
                                    clearInterval(interval)

                                    switch (response.mpago_status_detail) {
                                        case 'cc_rejected_bad_filled_card_number':
                                            message.error('Tu pago ha sido rechazado. Por favor, revisa los números de tu tarjeta')
                                            break;
                                        case 'cc_rejected_bad_filled_date':
                                            message.error('Tu pago ha sido rechazado. Por favor, revisa la fecha de expiración de tu tarjeta')
                                            break;
                                        case 'cc_rejected_bad_filled_security_code':
                                            message.error('Tu pago fue rechazado. Por favor, revisa tu codigo de seguridad')
                                            break;

                                        case 'cc_rejected_insufficient_amount':
                                            message.error('Pago rechazado por fondos insuficientes. Por favor intentá con otro medio de pago.')
                                            break;

                                        default:
                                            message.error('Tu pago fue rechazado. Por favor intentá con otro medio de pago.')
                                            break;
                                    }
                                    this.setState({ loading: false, paymentRejected: true })
                                    break;

                                case 'ERROR':
                                    clearInterval(interval)
                                    message.error('Ocurrio un error generando el pago. Reintenta más tarde')
                                    this.props.history.push('/mp')
                                    break;

                                case 'PENDING':
                                    break;

                                default:
                                    break;

                            }
                        }

                    })
                    .catch(err => {
                        message.error('Ocurrio un error leyendo el pago')
                        clearInterval(interval)
                        this.props.history.push('/')
                        console.log(err)
                    })
            })
    }

    setPaymentMethod(status, response) {
        if (status === 200) {
            let paymentMethod = response[0];
            this.setState({ mpResponse: paymentMethod })

            if (paymentMethod.additional_info_needed.includes("issuer_id")) {
                this.setState({ issuerRequired: true })
                this.getIssuers(paymentMethod.id)
            }
        } else {
            message.error(`Error en medio de pago: ${response}`);

        }
    }

    getIssuers(paymentMethodId) {

        window.Mercadopago.getIssuers(paymentMethodId, this.setIssuers)
    }

    setIssuers(status, response) {

        if (status === 200) {
            this.setState({ issuerOptions: response })
        }
        else {
            message.error(`Error obteniendo lista de bancos: ${response}`);
        };
    }

    getCardToken(event) {
        if (!this.state.doSubmit) {
            let $form = this.state.formData;
            window.Mercadopago.createToken($form, this.setCardTokenAndPay);
            return false;
        }
    }

    setCardTokenAndPay(status, response) {
        if (status === 200 || status === 201) {
            let cardToken = { ...this.state.card }
            cardToken['value'] = response.id
            let paymentMethodData = { ...this.state.formData }
            paymentMethodData['paymentMethod'] = this.state.mpResponse.payment_type_id
            paymentMethodData['paymentMethodId'] = this.state.mpResponse.id
            this.setState({ card: cardToken, formData: paymentMethodData })
            this.call_api()
        } else {

            switch (response.cause[0].code) {
                case 'E301':
                    message.error('Número de tarjeta inválido')
                    break
                case 'E302':
                    message.error('Revisa tu código de seguridad')
                    break
                case '316':
                    message.error('Nombre inválido!')
                    break
                case '322':
                    message.error('Tipo de documento inválido')
                    break
                case '323':
                    message.error('Revisa tu documento')
                    break
                case '324':
                    message.error('El documento es inválido')
                    break;
                case '325':
                    message.error('Mes de vencimiento inválido')
                    break;
                case '326':
                    message.error('Año de vencimiento inválido')
                    break;
                default:
                    message.error('Revisa los datos ingresados')
                    break;

            };
        }
    }

    updatePaymentId(entidad) {
        let aux = { ...this.state.formData }
        aux['paymentMethod'] = 'ticket'
        aux['paymentMethodId'] = entidad
        this.setState({ formData: aux })
        this.call_api()
    }

    render() {
        const { getFieldDecorator} = this.props.form;
        if (this.state.loading) {
            return (
                <>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }
        else {
            const documentNumberValidator = (rule, value, callback) => {
                if (isNaN(value.toString())) {
                    callback("DNI invalido")
                }
                else {
                    if (this.state.docMinLength <= value.toString().length && value.toString().length <= this.state.docMaxLength) {
                        callback()
                    } else {
                        callback('DNI incorrecto')
                    }
                }
            }
            return (
                <Card
                    style={{ marginBottom: 10 }}
                >
                    <Form>
                        <Row gutter={10}>
                            <h2> Datos del titular</h2>
                            <Col lg={6}>
                                <Form.Item label={'Nombre y Apellido'}>
                                    {
                                        getFieldDecorator('cardholderName', {
                                            rules: [{
                                                required: true,
                                                message: 'Nombre requerido'
                                            }],
                                            value: this.state.formData.cardholderName
                                        })(
                                            <Input
                                                disabled={false}
                                                placeholder={'Nombre titular tarjeta'}
                                                onChange={(e) => this.handleChange("cardholderName", e.target.value ? e.target.value : null)}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={6}>
                                <Form.Item label={'Email'}>
                                    {
                                        getFieldDecorator('email', {
                                            rules: [{
                                                required: true,
                                                message: 'Email requerido'
                                            }],
                                            value: this.state.formData.email
                                        })(
                                            <Input
                                                disabled={false}
                                                placeholder={'Email'}
                                                onChange={(e) => this.handleChange("email", e.target.value ? e.target.value : null)}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={6}>
                                <Form.Item label={'Tipo de Documento'}>
                                    {
                                        getFieldDecorator('docType', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Campo requerido',
                                                },
                                            ],
                                            value: this.state.formData.docType,
                                            initialValue: 'DNI',
                                        })(
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder={'Tipo de documento'}
                                                onChange={(value) => this.handleChange("docType", value ? value : null)}
                                                disabled={false}
                                            >
                                                {this.state.documentTypes.map(docs => {
                                                    return <Option key={docs.id} id={docs.id}>{docs.name}</Option>
                                                })}
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={6}>
                                <Form.Item label={'Nro Documento'}>
                                    {
                                        getFieldDecorator('docNumber', {
                                            rules: [
                                                {
                                                    required: true,
                                                },
                                                {
                                                    validator: documentNumberValidator
                                                }
                                            ],
                                            value: this.state.formData.docNumber,
                                            initialValue: null,
                                        })(
                                            <Input
                                                style={{ width: '100%' }}
                                                placeholder={'Nro Doc. titular'}
                                                onChange={(e) => this.handleChange("docNumber", e.target.value ? e.target.value : null)}
                                                disabled={false}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <h2>Datos de la tarjeta</h2>
                        <Row gutter={10}>
                            <Col lg={4}>
                                <Form.Item label={'Mes de Vencimiento'}>
                                    {
                                        getFieldDecorator('cardExpirationMonth', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Mes invalido',
                                                    min: 1,
                                                    max: 12
                                                }
                                            ],
                                            value: this.state.formData.cardExpirationMonth,
                                            initialValue: null,
                                        })(
                                            <Input
                                                style={{ width: '100%' }}
                                                placeholder={'MM'}
                                                onChange={(e) => this.handleChange("cardExpirationMonth", e.target.value ? e.target.value : null)}
                                                disabled={false}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={4}>
                                <Form.Item label={'Año de Vencimiento'}>
                                    {
                                        getFieldDecorator('cardExpirationYear', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Año invalido',
                                                }
                                            ],
                                            value: this.state.formData.cardExpirationYear,
                                            initialValue: null,
                                        })(
                                            <Input
                                                style={{ width: '100%' }}
                                                placeholder={'YYYY'}
                                                onChange={(e) => this.handleChange("cardExpirationYear", e.target.value ? e.target.value : null)}
                                                disabled={false}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={6}>
                                <Form.Item label={'Numero de tarjeta'}>
                                    {
                                        getFieldDecorator('cardNumber', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Tarjeta invalida',
                                                },
                                            ],
                                            value: this.state.formData.cardNumber,
                                            initialValue: null
                                        })(
                                            <Input
                                                onChange={(e) => this.handleChange("cardNumber", e.target.value ? e.target.value : null)}
                                                style={{ width: '100%' }}
                                                disabled={false}></Input>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={4}>
                                <Form.Item label={'CVV/Cod. seguridad'}>
                                    {
                                        getFieldDecorator('securityCode', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Codigo invalido',

                                                }
                                            ],
                                            value: this.state.formData.securityCode,
                                            initialValue: null,
                                        })(
                                            <Input
                                                style={{ width: '100%' }}
                                                onChange={(e) => this.handleChange("securityCode", e.target.value ? e.target.value : null)}
                                                disabled={false}
                                                suffix={
                                                    <Tooltip title="Visa/Master: 3 digitos al dorso. Amex: 4 digitos al frente">
                                                        <Icon type="info-circle" />
                                                    </Tooltip>
                                                }
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={4}>
                                <Form.Item label={'Banco Emisor'}
                                >
                                    {
                                        getFieldDecorator('issuer', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Seleciona tu Banco',
                                                },
                                            ],
                                            value: this.state.formData.issuer,
                                            initialValue: null
                                        })(
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={(value) => this.handleChange("issuer", value)}
                                                disabled={!this.state.issuerRequired}
                                                placeholder={'Banco Emisor'}>
                                                {this.state.issuerOptions.map(issuer => {
                                                    return <Option key={issuer.id} value={issuer.id}>{issuer.name}</Option>
                                                })}
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <br></br>
                        <Button type="primary" onClick={(e) => this.handleSubmit(e)}> Confirmar </Button>
                    </Form>
                    <img alt="mpago" src={mpago} className="mpago" style={{ height: "80px", marginTop: "15px", marginBottom: "15px", float: 'right' }} />
                </Card>
            )
        }
    }
}
const paymentComponent = Form.create({ name: 'paymentForm' })(MercadoPagoMP)
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(paymentComponent));
